import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useFetchUser } from "../../hooks/user/useFetchUser";
import { Roles } from "../../constants/UserRoles";
import Loading from "../common/Loading";

/**
 * Route guard that restricts access to admin-only routes.
 * Fetches the authenticated user from the DB and checks their role.
 * Non-admin users are redirected to /home.
 */
const RequireAdmin = () => {
  const { data: user, isLoading, error } = useFetchUser();

  if (isLoading) return <Loading />;

  if (error || !user || user.role !== Roles.Admin) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default RequireAdmin;
